import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayErrorToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { auditListRequest } from '../../../redux/audit/audit.action'
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import moment from "moment";
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";

const AuditList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { auditListSuccess, auditListError } = useSelector(state => state.audit)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [selectedTab, setSelectedTab] = useState(0)

    const TAB_ITEMS = {
        ALL: 'ALL',
        MY_AUDITS: 'MY AUDITS'
    }

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.AUDIT_LIST, true)
            fetchBusinessList()
        }
        if (isLoggedInUserEmployee(user)) {
            if (isPermissionAllowed(PERMISSION_SUB_TYPE.AUDIT.VIEW_ALL_AUDIT)) {
                fetchAuditList(selectedTab)
            } else {
                fetchAuditList(1)
            }
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.AUDIT_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.AUDIT_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(auditListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(auditListError)) {
            setLoading(false)
        }
    }, [auditListSuccess, auditListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchAuditList(selectedTab)
        }
    }, [selectedLocation])

    const fetchAuditList = (tabIndex) => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user)) {
            if (!isEmpty(selectedBusiness)) {
                data.businessId = selectedBusiness.businessId
                data.locationId = selectedLocation.locationId
            }
            if (tabIndex === 1) {
                data.id = user.data.userDetails.userId
                data.userType = user.data.userDetails.userType
            }
        } else if (isLoggedInUserEmployee(user)) {
            if (!isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
                data.businessId = employeeSelectedBusiness
                data.locationId = employeeSelectedLocation
            }
            if (tabIndex === 1) {
                data.id = user.data.userDetails.employeeId
                data.userType = user.data.userDetails.userType
            }
        }

        dispatch(auditListRequest(data))
    }

    const handleTabSelect = (item) => {
        if (item === TAB_ITEMS.ALL) {
            setSelectedTab((prevTab) => {
                const newTab = 0
                fetchAuditList(0)
                return newTab
            })
        } else {
            setSelectedTab((prevTab) => {
                const newTab = 1
                fetchAuditList(1)
                return newTab
            })
        }
    }

    const getStatusClassName = (status) => {
        if (status === APP_CONSTANTS.AUDIT_STATUS.COMPLETED) {
            return 'al-status-label al-status-green'
        } else if (status === APP_CONSTANTS.AUDIT_STATUS.NEW) {
            return 'al-status-label al-status-grey'
        } else if (status === APP_CONSTANTS.AUDIT_STATUS.ON_HOLD) {
            return 'al-status-label al-status-purple'
        } else if (status === APP_CONSTANTS.AUDIT_STATUS.PENDING) {
            return 'al-status-label al-status-yellow'
        } else if (status === APP_CONSTANTS.AUDIT_STATUS.IN_PROCESS) {
            return 'al-status-label al-status-orange'
        } else {
            return 'al-status-label'
        }
    }

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.AUDIT.VIEW_ALL_AUDIT) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.AUDIT, PERMISSION_SUB_TYPE.AUDIT.VIEW_ALL_AUDIT, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (pType === PERMISSION_SUB_TYPE.AUDIT.ADD_AUDIT) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.AUDIT, PERMISSION_SUB_TYPE.AUDIT.ADD_AUDIT, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }

    const handleAddAuditClick = () => {
        navigate(ROUTES.audit.newLog)
    }

    const handleViewDetail = (item) => {
        navigate(ROUTES.audit.details, {
            state: {
                auditId: item.auditId,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
                flowType: selectedTab === 0 ? 'ALL' : 'MY_AUDITS'
            }
        })
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Audit Logs' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                {isPermissionAllowed(PERMISSION_SUB_TYPE.AUDIT.VIEW_ALL_AUDIT) && <div className="al-tab-row-container">
                    <div
                        className={`al-row-item-container ${selectedTab === 0 ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_ITEMS.ALL) }}>{TAB_ITEMS.ALL}</div>
                    <div
                        className={`al-row-item-container ${selectedTab === 1 ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_ITEMS.MY_AUDITS) }}>{TAB_ITEMS.MY_AUDITS}</div>
                </div>}
                {!isNull(auditListSuccess) && !isEmpty(auditListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col" className="al-audit-title-head">Name</th>
                                <th scope="col" className="text-center">Type</th>
                                <th scope="col" className="text-center">Status</th>
                                {/* <th scope="col" className="text-center">Assignee</th>
                                <th scope="col" className="text-center">Assignee Id</th> */}
                                <th scope="col" className="text-center">Date</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {auditListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td className="al-audit-title">{element.title}</td>
                                    <td className="text-center">{!isEmpty(element.type) ? element.type : '-'}</td>
                                    <td className="text-center">
                                        <div className={getStatusClassName(element.status)}>
                                            {!isEmpty(element.status) ? removeSpecialCharAndChangeToPascal(element.status) : '-'}
                                        </div>
                                    </td>
                                    {/* <td className="text-center">{!isEmpty(element.assigneeDetails) ? `${element.assigneeDetails.firstName} ${element.assigneeDetails.lastName}` : '-'}</td>
                                    <td className="text-center">{!isEmpty(element.assigneeDetails) ? element.assigneeDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? element.assigneeDetails.employeeCode : removeSpecialCharAndChangeToPascal(element.assigneeDetails.userType) : '-'}</td> */}
                                    <td className="text-center">{moment.utc(element.date).local().format('DD MMM YYYY')}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(auditListError) && <div className="content-error">{auditListError.message}</div>}
                {isPermissionAllowed(PERMISSION_SUB_TYPE.AUDIT.ADD_AUDIT) && <div className="vl-fab-container" onClick={() => handleAddAuditClick()}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AuditList